import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoadingModule } from './loading/loading.module';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        HomeComponent,
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        HomeComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        LoadingModule,
        ReactiveFormsModule,
        InputTextModule,
        ButtonModule,
        DialogModule
    ]

})
export class CoreModule {

}